<template>
    <Dialog id="cookie_notice" position="bottomleft" header="Cookie Notice" :visible.sync="displayCookieNotice"
        :closable="false" :style="{ maxWidth: '400px' }" :modal="false">
        This site uses cookies in order to function correctly. By continuing to use our website, you consent to the use of
        cookies in accordance with our Cookie Policy. You can learn more about our use of
        cookies by reading our Cookie Policy.
        <template #footer>
            <Button label="Accept All Cookies" autofocus @click.prevent="triggerCookie()"/>
            <router-link to="/cookie-policy">
                <Button class="p-button-link" label="Cookie Policy"  />
            </router-link>
        </template>
    </Dialog>
</template>

<script>

export default {
    data() {
        return {
            displayCookieNotice: false
        }
    },
    mounted() {
        if (this.$cookie.get('cookie_consent') == '1') {
            this.displayCookieNotice = false;
        } else {
            this.displayCookieNotice = true;
        }
    },
    methods: {
        triggerCookie() {
            this.displayCookieNotice = false;
            this.$cookie.set('cookie_consent', 1, { expires: '12h' });
        }
    },
}
</script>